/* eslint-disable react/react-in-jsx-scope */
import { Grid, Tooltip } from "@material-ui/core";
import { TimelineSeparator } from "@material-ui/lab";
import { DATE_FORMAT_PRINT } from "config/constants";
import { TasksIconDetail, TasksService } from "config/status";
import useText from "constants/text";
import { vehicleToReturn } from "domains/Request/component/Tour/refontTourRequest/Collapse";
import { Driver, EVehiculeType, PapsService, Runsheet, Stop, Task, TaskMission } from "generated/graphql";
import { UserIcon } from "icons";
import moment from "moment";
import { useMemo } from "react";
import { TimelineConnector, TimelineDot, TimelineItem } from "./TaskDetailsMAD";
import { useTaskStyles } from "./style";

interface ITaskDetailTitle {
  stops?: Stop[];
  creationDate?: string;
  service?: PapsService | any;
  vehicle?: any;
  driver?: Driver;
  runsheet?: Runsheet;
  task?: TaskMission & Task;
}

function TaskDetailTitle({ stops, creationDate, runsheet, service, vehicle, driver, task }: ITaskDetailTitle) {
  const styles = useTaskStyles({ service });
  const { text } = useText();
  const regionsTodisplay = useMemo(() => {
    const regions = stops
      ?.map((stop) => stop?.address?.region)
      .reduce((uniqList, currentItem) => (uniqList.includes(currentItem) ? uniqList : [currentItem, ...uniqList]), [])
      .sort();
    return regions.join(", ");
  }, [stops]);

  const renderVehicles = (vehicleType: string, vehicleName: string) => (
    <div className={styles.renderVehicles}>
      <div className="vehicleType">{vehicleType}</div>
      <div className="vehicleName">{vehicleName}</div>
    </div>
  );

  const renderVehiclesFunc = (data: any) => {
    switch (data) {
      case EVehiculeType.Scooter:
        return renderVehicles(vehicleToReturn[data], EVehiculeType.Scooter);
      case EVehiculeType.Tricycle:
        return renderVehicles(vehicleToReturn[data], EVehiculeType.Tricycle);
      case EVehiculeType.MiniVan:
        return renderVehicles(vehicleToReturn[data], EVehiculeType.MiniVan);
      case EVehiculeType.Van:
        return renderVehicles(vehicleToReturn[data], EVehiculeType.Van);

      default:
        break;
    }
  };

  return (
    <Grid container spacing={3} className={styles.gridContainer}>
      <Grid item xs={4}>
        <div className={styles.TaskIcon}>{TasksIconDetail(service, 45)}</div>
      </Grid>
      <Grid item>
        <div className={styles.taskServiceMsg}>{TasksService[service]}</div>
        {[PapsService.Mad, PapsService.Nt, PapsService.Tr].includes(service) ? (
          <div className={styles.driverInfos}>
            <div className={styles.driverName}>
              <div className={styles.titleContainer}>
                {service === PapsService.Mad ? (
                  <TimelineItem>
                    <TimelineSeparator>
                      <TimelineDot
                        customColor="#757a93"
                        backgroundColor="#2f80ed"
                        className={styles.timelineDot}
                      ></TimelineDot>
                      <TimelineConnector />
                    </TimelineSeparator>
                    <span className={styles?.addressMad}>{task?.task_subtasks?.[0]?.subtask_address?.address}</span>
                  </TimelineItem>
                ) : null}
                {service !== PapsService.Tr ? (
                  <div className={styles.driverInfosContainer}>
                    <UserIcon width={21} height={21} />{" "}
                    {runsheet && runsheet?.runsheet_driver ? <Tooltip title={`${text.all.phone_number} ${runsheet?.runsheet_driver?.driver_firstname}`}>
                      <div>{`${runsheet?.runsheet_driver?.driver_firstname || ""} ${runsheet?.runsheet_driver?.driver_lastname || ""}`}</div>
                    </Tooltip> :
                      driver ? <Tooltip title={`${text.all.phone_number} ${driver?.driver_phone_number}`}>
                        <div>{`${driver?.driver_firstname || ""} ${driver?.driver_lastname || ""}`}</div>
                      </Tooltip> : "N/A"}
                  </div>
                ) : null}
              </div>
            </div>
            {service !== PapsService.Mad ? (
              <div className={styles.vehicle}>{renderVehiclesFunc(vehicle?.vehicleType)}</div>
            ) : null}
          </div>
        ) : (
          <div className={styles.addressRegion}>
            <div>{regionsTodisplay}</div>
          </div>
        )}
      </Grid>
      <Grid item>
        <div className={styles.createDate}>
          <div className={styles.dateAndVehicule}>{moment(creationDate).format(DATE_FORMAT_PRINT)}</div>
          {service === PapsService.Mad ? (
            <div className={styles.vehiculeType}>
              <span>{vehicleToReturn[vehicle]}</span>
              <span>{vehicle?.toLowerCase()?.replace(/_/g, " ")}</span>
            </div>
          ) : null}
        </div>
      </Grid>
    </Grid>
  );
}

export default TaskDetailTitle;
